import { Message } from 'element-ui';

const plugin = {};

const showResponseErrorMsg = (error) => {
  const { response, message } = error;
  let errorMessage = '';
  if (response) {
    switch (response.status) {
      case 400:
        errorMessage = '请求错误(400): 参数格式有误，请检查！';
        break;
      case 401:
        errorMessage = '未授权(401): 登录已过期，请重新登录！';
        break;
      case 403:
        errorMessage = '未授权(403): 暂无操作权限，请检查！';
        break;
      case 404:
        errorMessage = '资源未找到(404): 请求的内容不存在，请稍后再试！';
        break;
      case 500:
        errorMessage = '服务器错误(500): 服务器开小差了，请稍后再试！';
        break;
      case 502:
        errorMessage = '网关错误(502): 服务暂时不可用，请稍后再试！';
        break;
      case 503:
        errorMessage = '服务不可用(503): 系统维护中，请稍后重试！';
        break;
      case 504:
        errorMessage = '网关超时(504): 请求超时，请稍后再试！';
        break;
      default:
        errorMessage = `未知错误(${response.status}): ${response.statusText}`;
    }
  } else if (message && message.toLowerCase().includes('network error')) {
    // 处理网络相关错误
    errorMessage = '请检查网络连接或稍后再试！';
  } else if (error.request) {
    // 请求已发出但没有收到响应
    errorMessage = '请检查网络连接或稍后再试！';
  } else {
    // 其他错误
    errorMessage = `错误: ${error.message ? error.message : '未知错误'}`;
  }
  return errorMessage;
};


plugin.install = (Vue, axios) => {
  if (plugin.installed || !axios) {
    return;
  }
  plugin.installed = true;

  // bind axios to Vue
  Vue.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios;
      },
    },
    $http: {
      get() {
        return axios;
      },
    },
  });

  // global set axios
  axios.defaults.headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  axios.defaults.baseURL = '';

  let loadingAnimation;

  Vue.startLoading = function startLoading() {
    if (!document.getElementById('loadingbar')) {
      const $loadingbar = document.createElement('div');
      $loadingbar.id = 'loadingbar';
      $loadingbar.className = 'waiting';
      $loadingbar.innerHTML = '<dt/><dd/>';
      document.body.appendChild($loadingbar);

      const $loadingbarspinner = document.createElement('div');
      $loadingbarspinner.id = 'loading-bar-spinner';
      $loadingbarspinner.innerHTML = '<div class="spinner-icon"></div>';
      document.body.appendChild($loadingbarspinner);

      let width = 1;
      // eslint-disable-next-line
      loadingAnimation = setInterval(function () {
        if (width >= 90) {
          clearInterval(loadingAnimation);
        }
        // eslint-disable-next-line
        $loadingbar.style.width = `${width++}%`;
      }, 10);
    }
  };
  Vue.endLoading = function endLoading() {
    const $loadingbar = document.getElementById('loadingbar');
    const $spinner = document.getElementById('loading-bar-spinner');
    if ($loadingbar && $spinner) {
      clearInterval(loadingAnimation);
      $loadingbar.className = 'end';
      $loadingbar.style.width = '101%';
      document.body.removeChild($spinner);
      // eslint-disable-next-line
      setTimeout(function () {
        document.body.removeChild($loadingbar);
      }, 600);
    }
  };
  // set axios
  let startTimestamp;
  // let endTimestamp;
  const loadingStack = [];

  axios.interceptors.request.use(
    config => {
      startTimestamp = new Date().getTime();
      if (loadingStack.length === 0) {
        Vue.startLoading();
      }
      loadingStack.push(startTimestamp);
      return config;
    },
    error => {
      Promise.reject(error);
    }
  );

  function showMessage(response) {
    const data = response.data;
    const config = response.config;
    if (data && !config.hideMessage) {
      const errno = response.data.errno;
      let msg = data.errmsg;
      let type = 'error';
      if (+errno !== 0) {
        Message({
          message: msg || (type === 'success' ? '操作成功' : '操作失败，请稍候再试'),
          type,
        });
      }
    }
  }

let isShowLogoutMsg = false;
    
const ResponseCodeMap = {
  'logout': 110003,
}

axios.interceptors.response.use(
  response => {
    const {
      errno = '',
      errmsg,
      data = {
        url: '',
      },
    } = response.data;
    if (Number(errno) === ResponseCodeMap.logout) {
      if (!isShowLogoutMsg) {
        Message({
          message: errmsg || "未登录",
          type: "error"
        });
      }
      isShowLogoutMsg = true;
      window.location.href = data.url;
      return;
    }
    if (response.data) {
      showMessage(response);
    }
    if (loadingStack.length === 1) {
      Vue.endLoading();
    }
    loadingStack.pop();
    return Promise.resolve(response.data);
  },
  error => {
    const errMsg = showResponseErrorMsg(error);
    Message({
      message: errMsg || '系统错误',
      type: 'error',
    });
    if (loadingStack.length === 1) {
      Vue.endLoading();
    }
    loadingStack.pop();
    return Promise.reject(error);
  }
);
};
export default plugin;
